export function getCircleRadians(radians: number[], isbtw: boolean) {
  const r = [...radians];
  return isbtw ? [r[1], r[0], r[2]] : r;
}